import { useLazyLoginByMagicLinkQuery } from 'feature/company/redux/company.api'
import { AuthStatus } from 'feature/auth/redux/authSlice'
import { MainLayout } from 'layouts'
import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Loading } from 'router/Loading'
import { useActions } from 'store/hooks'

export function CompanyMagicLinkLogin() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const { setAuthInfo } = useActions()
  const [error, setError] = useState<string | null>(null)
  const [triggerLogin] = useLazyLoginByMagicLinkQuery()
  const calledRef = useRef(false)

  useEffect(() => {
    if (!token || calledRef.current) return
    calledRef.current = true

    triggerLogin(token)
      .unwrap()
      .then(data => {
        setAuthInfo({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          status: AuthStatus.registered,
        })
      })
      .catch(() => {
        setError('Ссылка недействительна или истекла. Запросите новую.')
      })
  }, [token])

  if (error) {
    return (
      <MainLayout>
        <div className='container'>
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <p className='h1'>Ошибка входа</p>
            <p className='default-text' style={{ marginTop: 12 }}>
              {error}
            </p>
            <a
              href='/company/login'
              className='default-text'
              style={{
                color: 'var(--primary-main)',
                marginTop: 16,
                display: 'inline-block',
              }}
              data-testid='magic-link-back-to-login'
            >
              Вернуться на страницу входа
            </a>
          </div>
        </div>
      </MainLayout>
    )
  }

  return (
    <MainLayout>
      <Loading />
    </MainLayout>
  )
}
